export class UserFile {
  public file: File;
  public fileUrl: string;

  constructor(file: File, fileUrl: string) {
    this.file = file;
    this.fileUrl = fileUrl;
  }
}
